export default class DestinationsEffectivePermissionModel {
    constructor({permission_name, permission_types, edges}) {
        this.permissionName = permission_name;
        this.jpus = edges;
        this.distribute = permission_types && permission_types.indexOf('DISTRIBUTE') >= 0;
        this.delete = permission_types && permission_types.indexOf('DELETE') >= 0;
        this.managed = permission_types && permission_types.indexOf('MANAGE') >= 0;
    }
}



// WEBPACK FOOTER //
// ./models/DestinationsEffectivePermissionModel.js